<template>
    <div :style="{
        border: '0px',
        clip: 'rect(0px, 0px, 0px, 0px)',
        'clip-path': 'inset(50%)',
        height: '1px',
        margin: '0px -1px -1px 0px',
        overflow: 'hidden',
        padding: '0px',
        position: 'absolute',
        width:'1px',
        'white-space': 'nowrap'
    }">
        <slot />
    </div>
</template>

<script>

/**
 * VisuallyHidden hides its children visually, while keeping content visible to screen readers.
 * ref: https://react-spectrum.adobe.com/react-aria/VisuallyHidden.html
 */
export default {
  name: 'i-visually-hidden',
};
</script>
